import { SET_VHOST_REQUEST_LOCATION } from '../actionTypes';

export const setVHostRequestLocation = ({ protocol, hostname, port }) => ({
    type: SET_VHOST_REQUEST_LOCATION,
    payload: { protocol, hostname, port },
});
